import { useState } from 'react';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import { Button } from './Button';

import styles from './checkbutton.module.scss';

export type CheckButtonProps = {
  initiallyChecked?: boolean;
  onClick: (newState: boolean) => void;
};

export const CheckButton = ({
  children,
  initiallyChecked,
  onClick,
}: React.PropsWithChildren<CheckButtonProps>) => {
  const [checked, setChecked] = useState(initiallyChecked);

  return (
    <Button
      icon={
        checked ? (
          <GoogleFontIcon name="check" className={styles['icon']} />
        ) : undefined
      }
      iconPosition="right"
      variant={checked ? 'primary' : 'secondary'}
      onClick={() => {
        onClick(!checked);
        setChecked((value) => !value);
      }}
    >
      {children}
    </Button>
  );
};
